import React, { Component } from 'react'
import { connect } from "react-redux";
import './style.css'
import { getClients } from "../../login/reducers/manageLogin";
import { Typeahead } from "react-bootstrap-typeahead";
import { ControlLabel } from "react-bootstrap";
import DataSourceDropdown from "./components/DataSourceDropdown";


class DataAccessRequest extends Component {
  state = {
    selectedClient: []
  }

  componentDidMount() {
    this.props.getClients({ 'has_data_sources': true })
  }

  render() {
    const { clients, fetchingClients } = this.props
    const { selectedClient } = this.state

    return (
      <div id="DataAccessRequest">
        { fetchingClients ?
          <center>
            <div id="not-found">
              <img alt="loader" src={require("../../../static/images/spinner.gif")} />
            </div>
          </center>
          :
          <React.Fragment>
            <div className="form-input-container">
              <ControlLabel>
                Select Client(s)
              </ControlLabel>
              <Typeahead
                style={{ margin: "25px" }}
                id='SelectClientTypeahead'
                labelKey={ client => `${client.name} ${client.short_code}` }
                options={ clients }
                selected={ this.state.selectedClient }
                onChange={ (selectedClient) => this.setState({ selectedClient }) }
                placeholder="Select client"
              />
            </div>
            { !!selectedClient.length &&
              <DataSourceDropdown selectedClient={ selectedClient[0] } />
            }
          </React.Fragment>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clients: state.manageLogin.clients,
    fetchingClients: state.manageLogin.fetchingClients,
  }
}

export default connect(mapStateToProps, { getClients })(DataAccessRequest)


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequest/index.js